import React, { useState, useEffect } from "react";
import { Context } from "../backend/context";

import { Link } from "react-router-dom";

function Leaderboard() {
  const { uid, total } = React.useContext(Context);
  const [leaderBoard, setLeaderboard] = useState([]);
  const [type, setType] = useState("TODAY");
  const [totalVolume, setTotalVolume] = useState(0);
  const [totalProfit, setTotalProfit] = useState(0);

  function compare(a, b) {
    if (a.volume < b.volume) {
      return 1;
    }
    if (a.volume > b.volume) {
      return -1;
    }
    return 0;
  }

  useEffect(() => {
    var list = [];
    var totalVolume = 0;
    var totalProfit = 0;
    if (type === "TODAY") {
      for (var i in total.todayLeaderBoard) {
        totalVolume += total.todayLeaderBoard[i].volume;
        totalProfit += total.todayLeaderBoard[i].profit;
        list.push(total.todayLeaderBoard[i]);
      }
    } else if (type === "YESTERDAY") {
      for (var j in total.yesterdayLeaderBoard) {
        totalVolume += total.yesterdayLeaderBoard[j].volume;
        totalProfit += total.yesterdayLeaderBoard[j].profit;
        list.push(total.yesterdayLeaderBoard[j]);
      }
    } else if (type === "WEEK") {
      for (var k in total.weeklyLeaderBoard) {
        totalVolume += total.weeklyLeaderBoard[k].volume;
        totalProfit += total.weeklyLeaderBoard[k].profit;
        list.push(total.weeklyLeaderBoard[k]);
      }
    }
    // else if (type === "MONTH") {
    //   for (var k in total.monthlyLeaderBoard) {
    //     totalVolume += total.monthlyLeaderBoard[k].volume;
    //     totalProfit += total.monthlyLeaderBoard[k].profit;
    //     list.push(total.monthlyLeaderBoard[k]);
    //   }
    // } else if (type === "NEOUSDC") {
    //   for (var k in total.neoLeaderBoard) {
    //     totalVolume += total.neoLeaderBoard[k].volume;
    //     totalProfit += total.neoLeaderBoard[k].profit;
    //     list.push(total.neoLeaderBoard[k]);
    //   }
    // }
    // else if (type === "LASTMONTH") {
    //   for (var l in total.lastweekLeaderBoard) {
    //     totalVolume += total.lastweekLeaderBoard[l].volume;
    //     totalProfit += total.lastweekLeaderBoard[l].profit;
    //     list.push(total.lastweekLeaderBoard[l]);
    //   }
    // }
    setTotalVolume(totalVolume);
    setTotalProfit(totalProfit);

    setLeaderboard(list.sort(compare));
  }, [total, type]);

  return (
    <div className="py-5 container text-left badge-dark">
      {false && (
        <div className="row mt-3 ">
          <div className="col-12 col-sm-8 m-auto">
            <div className="row rounded-lg border-black border no-gutters">
              <div
                className=" col-12 text-left rounded-lg p-3"
                style={{ backgroundColor: "#04093b" }}
              >
                <span className="h3 mb-2">Cloudbot trading competition</span>{" "}
                <div className="row">
                  <div className="col-sm-8 col-12 mt-2">
                    Run bots on <strong>NEO-USDC</strong> market to win prizes.
                    <br />
                    Competition start on 31st March 0:00 UTC and end on 6th
                    April 23:59 UTC.
                  </div>{" "}
                  <div className="col-12 col-sm-4 mt-2 text-center">
                    <span className="text-left h5 ">
                      Top prize - <strong>$500</strong>
                      <br />
                      2nd prize - <strong>$300</strong> <br />
                      3-5 - <strong>$100</strong> each.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-11 col-sm-10 m-auto">
          <div className="row mt-2">
            {false && (
              <div className="col-3 text-center p-0 overflow-hidden ">
                <button
                  onClick={() => setType("NEOUSDC")}
                  type="button"
                  className="btn btn-dark w-100 m-0 px-0"
                  style={{ backgroundColor: "black" }}
                >
                  NEO-USDC
                </button>
              </div>
            )}

            <div className="col-4 text-center px-0 overflow-hidden m-auto h-100">
              <button
                onClick={() => setType("WEEK")}
                type="button"
                className="btn btn-dark w-100 m-0 px-0 h-100 m-auto"
                style={{ backgroundColor: "black" }}
              >
                Week
              </button>
            </div>

            <div className="col-4 text-center px-0 overflow-hidden m-auto h-100">
              <button
                onClick={() => setType("YESTERDAY")}
                type="button"
                className="btn btn-dark w-100 m-0 px-0 h-100 m-auto"
                style={{ backgroundColor: "black" }}
              >
                Yesterday
              </button>
            </div>
            <div className="col-4 text-center px-0 overflow-hidden m-auto h-100">
              <button
                onClick={() => setType("TODAY")}
                type="button"
                className="btn btn-dark w-100 m-0 px-0 h-100 m-auto"
                style={{ backgroundColor: "black" }}
              >
                Today
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-12 h4 p-1 m-1  text-center">
              {type === "TODAY"
                ? "Today"
                : type === "WEEK"
                ? "Week"
                : type === "MONTH"
                ? "Nash League"
                : type === "LASTMONTH"
                ? "Last Month"
                : type === "NEOUSDC"
                ? "NEO-USDC Competition"
                : "Yesterday"}
              's LeaderBoard
            </div>
          </div>
          <div className="row">
            <div
              className="col-12"
              style={{ maxWidth: "100%", overflowX: "scroll" }}
            >
              <div
                style={{ minWidth: "400px" }}
                className="row rounded-top rounded-lg"
              >
                <div className="col-2 badge-secondary border-bottom py-2 border-right border-dark  h6 m-0 text-center verticalCenter">
                  Rank
                </div>{" "}
                <div className="col-2 badge-secondary border-bottom py-2 border-right border-dark  h6 m-0 text-center verticalCenter">
                  User
                </div>
                <div className="col-3 badge-secondary border-bottom border-right py-2 border-dark h6 m-0 text-center verticalCenter">
                  Total Volume ($)
                </div>
                {false && (
                  <div className="col-2 badge-secondary border-bottom py-2 border-dark border-right h6 m-0 text-center verticalCenter">
                    Taker Volume ($)
                  </div>
                )}
                <div className="col-3 badge-secondary border-bottom py-2 border-dark border-right h6 m-0 text-center verticalCenter">
                  Profit ($)
                </div>
                <div className="col-2 badge-secondary border-bottom py-2 border-dark h6 m-0 text-center verticalCenter">
                  Profit (%)
                </div>
              </div>
              {leaderBoard.length > 0 ? (
                leaderBoard.map((item, key) => (
                  <div style={{ minWidth: "400px" }} key={key} className="row ">
                    <div
                      className="col-2 border-bottom border-secondary border-right  p-1 text-center  overflow-hidden"
                      style={{
                        backgroundColor: "#292b2c",
                        fontSize: "0.9rem",
                        color: "#e4e6e7",
                      }}
                    >
                      {key + 1}
                    </div>
                    <div
                      className="col-2 border-bottom border-secondary border-right  p-1 text-center  overflow-hidden"
                      style={
                        item.id === uid
                          ? {
                              backgroundColor: "#1f1f7a",
                              maxHeight: "2rem",
                              fontSize: "0.9rem",
                            }
                          : {
                              backgroundColor: "#292b2c",
                              fontSize: "0.9rem",
                              color: "#e4e6e7",
                              maxHeight: "2rem",
                            }
                      }
                    >
                      {item.nickName
                        ? item.nickName
                        : item.id.slice(0, 3).toUpperCase()}
                    </div>
                    <div
                      className="col-3 border-bottom border-secondary border-right p-1 text-center  overflow-hidden"
                      style={{
                        backgroundColor: "#292b2c",
                        fontSize: "0.9rem",
                        color: "#e4e6e7",
                      }}
                    >
                      {item.volume
                        .toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                        })
                        .slice(1)}
                    </div>

                    {false && (
                      <div
                        className="col-2 border-bottom border-secondary border-right p-1 text-center  overflow-hidden"
                        style={{
                          backgroundColor: "#292b2c",
                          fontSize: "0.9rem",
                          color: "#e4e6e7",
                        }}
                      >
                        {item.takerVolume
                          .toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                          })
                          .slice(1)}
                      </div>
                    )}

                    <div
                      className="col-3 border-bottom border-secondary border-right p-1 text-center  overflow-hidden"
                      style={{
                        backgroundColor: "#292b2c",
                        fontSize: "0.9rem",
                        color: "#e4e6e7",
                      }}
                    >
                      {item.profit.toFixed(2)}
                    </div>
                    <div
                      className="col-2 border-bottom border-secondary  p-1 text-center  overflow-hidden"
                      style={{
                        backgroundColor: "#292b2c",
                        fontSize: "0.9rem",
                        color: "#e4e6e7",
                      }}
                    >
                      {(item.volume > 0
                        ? (item.profit * 100) / item.volume
                        : 0
                      ).toFixed(2)}
                    </div>
                  </div>
                ))
              ) : (
                <div
                  style={{ minWidth: "400px" }}
                  className="row border border-dark "
                >
                  <div className="col-12 text-center  overflow-hidden">
                    No Data
                  </div>
                </div>
              )}

              <div
                className="row border border-dark "
                style={{ minWidth: "400px" }}
              >
                <div className="col-2 border-bottom border-top border-secondary border-right border-left  p-2 text-center  overflow-hidden">
                  Total Volume
                </div>
                <div className="col-4 border-bottom border-top border-secondary border-right p-2 text-center  overflow-hidden">
                  {totalVolume.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })}
                </div>
                <div className="col-2 border-bottom border-top border-secondary border-right  p-2 text-center  overflow-hidden">
                  Total Profit
                </div>
                <div className="col-2 border-bottom border-top border-secondary border-right p-2 text-center  overflow-hidden">
                  {totalProfit.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })}
                </div>
                <div className="col-2 border-bottom border-top border-secondary border-right p-2 text-center  overflow-hidden">
                  {((totalProfit * 100) / totalVolume).toFixed(2)} %
                </div>
              </div>
            </div>{" "}
          </div>{" "}
        </div>
      </div>
      <div className="row mt-3">
        {uid ? (
          <div className="col-sm-6 col-12 m-auto text-center">
            <Link to="/account" className="btn btn-secondary px-3 w-50">
              Back
            </Link>
          </div>
        ) : (
          <div className="col-sm-6 col-12 m-auto text-center">
            <Link to="/" className="btn btn-secondary px-3 w-50">
              Sign In
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default Leaderboard;
